<template>
    <div class="custom-select-wrapper new-select" @click="selectOpen($event)">
        <div class="custom-select">
            <div class="custom-select__trigger">
              <span v-text="categories.placeholder"></span>
              <div class="arrow"></div>
            </div>
            <div class="custom-options">
                <div class="item" @click="getOption($event, item)" v-for="item in categories.list">
                    <div class="item-label" >
                        <span class="item-mask" v-text="item.name"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['categories'],
    name: "TabSelect",
    data(){
        return{}
    },

    created(){
        this.appRoutes = window.appRoutes;
        window.addEventListener('click', this.selectClose)
    },

    destroyed(){
        window.removeEventListener('click', this.selectClose)
    },

    mounted(){

    },
    methods:{

        selectClose(e){
            let selects = document.querySelectorAll('.custom-select');

            for(let select of selects){
                if(!select.contains(e.target)){

                    select.classList.remove('open')

                }
            }


        },
        selectOpen(e){
            e.target.classList.toggle('open')
        },
        getOption(e, item){
            let opt = e.target


            if (!opt.classList.contains('selected')) {
                if(opt.parentNode.querySelector('.item.selected'))opt.parentNode.querySelector('.item.selected').classList.remove('selected');
                opt.classList.add('selected');
                opt.closest('.custom-select').querySelector('.custom-select__trigger span').innerHTML = opt.querySelector('.item-mask').innerHTML;

                if(item){
                    this.$emit('selectHook', item)
                }

                setTimeout(()=>{
                    opt.closest('.custom-select').classList.remove('open')
                }, 300)
            }

        },


    }
}
</script>

<style scoped>

</style>
